import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import products from 'src/assets/images/products.svg'

const AllProducts = () => {
  const classes = useStyles()
  return (
    <div className={classes.allProductsContainer}>
      <div className={classes.productDiv}>
        <div className={classes.productTopDiv}>
          <p className={classes.productTopText}>
            We are going to excite you with our new innovative products shortly.
          </p>
        </div>
        <div className={classes.productImageDiv}>
          <img src={products} className={classes.productImage} />
        </div>
        <div className={classes.productBottomDiv}>
          <p className={classes.productBottomText}>
            Please wait for our notification.
          </p>
        </div>
      </div>
    </div>
  )
}

export default AllProducts

const useStyles = makeStyles({
  buttonUploadPersonal: {
    textTransform: 'unset',
    fontSize: '11px',
    fontWeight: '600',
    background: COLORS.WHITE,
    color: COLORS.MEDIUM_LIGHTBLUE,
    // margin: "-4px 0 10px 9px",
    height: '24px',
    padding: '15px 20px !important',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: COLORS.WHITE,
    },
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
  },
  productImageDiv: {
    padding: '30px 0px',
    textAlign: 'center',
  },
  productImage: {
    width: '50% !important',
  },
  productBottomText: {
    margin: '0px 0px',
    color: '#B92250',
    textTransform: 'uppercase',
  },
  productBottomDiv: {
    padding: '10px 0px 30px 0px',
    textAlign: 'center',
  },
  allProductsContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  productDiv: {
    width: '50vw',
    backgroundColor: 'white',
    borderRadius: '20px',
  },
  productTopText: {
    margin: '0px 0px',
    color: '#6A6A6A',
    padding: '0px 150px',
  },
  productTopDiv: {
    padding: '30px 0px 25px 0px',
    textAlign: 'center',
  },
})
